import { FC } from 'react'
import styled from 'styled-components'

interface SwitcherProps {
  checked?: boolean;
  withLabel?: boolean;
  rightLabel?: boolean;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  onClick?: (selected: boolean) => void;
  styledCheckBoxColor?: string;
  toggledColor?: string;
  uncheckedColor?: string;
}

const Switcher: FC<SwitcherProps> = ({
  checked = false,
  disabled = false,
  withLabel,
  rightLabel,
  onClick,
  className,
  children,
  styledCheckBoxColor,
  toggledColor,
  uncheckedColor
}) => {
  const onCheck = () => {
    if (!disabled && onClick) {
      onClick(!checked)
    }
  }
  return (
    <StyledContainer className={className}>
      {withLabel && !rightLabel && <label className="left">{children}</label>}
      <CheckboxContainer>
        <StyledCheckbox
          type="checkbox"
          onChange={onCheck}
          checked={checked}
          toggledColor={toggledColor}
          uncheckedColor={uncheckedColor}
        />
        <StyledSwitcher className="styled-switcher" uncheckedColor={uncheckedColor} checked={checked}/>
      </CheckboxContainer>

      {withLabel && rightLabel && <label className="right">{children}</label>}
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  align-items: center;
  display: flex;
  z-index: 0;
  position: relative;
  font-size: 16px;
  line-height: 1.5;

  .right {
    margin-left: 1rem;
  }

  .left {
    margin-right: 1rem
  }
`

const CheckboxContainer = styled.div`
  display: flex;
  position: relative;
`

const StyledCheckbox = styled.input<{ toggledColor: string, uncheckedColor: string }>`
  position: absolute;
  appearance: none;
  width: 36px;
  height: 20px;
  cursor: pointer;
  z-index: 1;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  &:checked + span {
    background-color: var(--switch-color);

    &:before, &:after {
      left: 18px;
    }

    &:after {
      background-color: #FFFFFF;
      opacity: 1;
    }
  }
`

const StyledSwitcher = styled.span<{uncheckedColor: string, checked: boolean}>`
  content: "";
  display: inline-block;
  position: relative;
  width: 36px;
  height: 20px;
  background-color: var(--switch-color);
  opacity: ${({ checked }) => checked ? 1 : 0.3};
  border-radius: 20px;
  margin-right: 10px;
  transition: background 0.3s ease, opacity 0.3s ease;

  &:before, &:after {
    content: "";
    position: absolute;
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    left: 2px;
    top: 2px;
    transition: left 0.3s ease, background .3s ease, box-shadow 0.1s ease, transform .1s ease;
  }

  &:before {
    background-color: transparent;
  }

  &:after {
    background-color: #FFFFFF;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`

export default Switcher